var RULES = /* @__PURE__ */ ((RULES2) => {
  RULES2["RULE_MIN"] = "min";
  RULES2["RULE_CASE"] = "case";
  RULES2["RULE_LOW_CASE"] = "low";
  RULES2["RULE_UP_CASE"] = "up";
  RULES2["RULE_SPEC"] = "spec";
  RULES2["RULE_DIGIT"] = "digit";
  return RULES2;
})(RULES || {});
var STATES = /* @__PURE__ */ ((STATES2) => {
  STATES2[STATES2["STATE_PASSED"] = 0] = "STATE_PASSED";
  STATES2[STATES2["STATE_FAILED"] = 1] = "STATE_FAILED";
  STATES2[STATES2["STATE_DISABLED"] = 2] = "STATE_DISABLED";
  return STATES2;
})(STATES || {});
const WsPasswordStrengthEnum = {
  Rules: RULES,
  States: STATES
};
export {
  WsPasswordStrengthEnum as default
};
//# sourceMappingURL=WsPasswordStrength.enum.es.js.map
